const initialState = {
  calleDeVolcadora: null,
  cerealVolcadoras: null,
  cerealVolcadorasOriginal: null,
  volcadorasCamiones: [],
  volcadorasConCereal: null,
  isRequestingVolcadora: false,
  selectedVolcadoraCamiones: null,
  silosValidosVolcadora: [],
  motivosDemoraVolcadora: []
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case 'CALLE_DE_VOLCADORA':
      return {
        ...state,
        calleDeVolcadora: action.calleDeVolcadora
      }
    case 'RECEIVE_VOLCADORA_CEREAL_ASIGNADO':
      return {
        ...state,
        cerealVolcadoras: action.resultado
      }
    case 'RECEIVE_VOLCADORA_CON_CEREAL_ASIGNADO':
      return {
        ...state,
        volcadorasConCereal: action.data
      }
    case 'RECEIVE_VOLCADORA_CEREAL_ORIGINAL':
      return {
        ...state,
        cerealVolcadorasOriginal: action.resultado
      }
    case 'REQUEST_VOLCADORA_CAMIONES':
      return {
        ...state,
        isRequestingVolcadora: true
      }
    case 'RECEIVE_VOLCADORA_CAMIONES':
      return {
        ...state,
        isRequestingVolcadora: false,
        volcadorasCamiones: action.volcadorasCamiones
      }
    case 'SET_VOLCADORA_CAMIONES':
      return {
        ...state,
        selectedVolcadoraCamiones: action.volcadora
      }
    case 'SILOS_VALIDOS_VOLCADORA':
      return {
        ...state,
        silosValidosVolcadora: action.data
      }
    case 'RECEIVE_MOTIVOS_DEMORA_VOLCADORA':
      return {
        ...state,
        motivosDemoraVolcadora: action.motivos
      }
    default:
      return state
  }
}
